module.exports = __webpack_public_path__ + "assets/img/6140b3d93b7142f19705bdf688d0ba1c.svg";